import {Component, Input, OnInit} from '@angular/core';
import {LoaderService} from '../../../../services/common/loader-service/loader.service';
import {RoutingRuleApiService} from '../../../../services/api/routing/routing-rule/routing-rule-api.service';
import {
  CallStudioApiService
} from '../../../../services/api/settings/call-flow-configurations/call-studio/call-studio-api.service';
import {RoutingGroupApiService} from '../../../../services/api/routing-group/routing-group-api.service';
import _ from 'lodash';

@Component({
  selector: 'prefix-groups-summary',
  templateUrl: './prefix-groups-summary.component.html',
  styleUrls: ['./prefix-groups-summary.component.scss']
})
export class PrefixGroupsSummaryComponent implements OnInit {

  routingGroupIdToNameMap;
  rules;
  policyStudio;
  prefixGroup;

  @Input()
  set selection(selection: any) {
    this.initializeData(selection);
  }

  constructor(private routingRuleApi: RoutingRuleApiService,
              private callStudioApiService: CallStudioApiService,
              private loaderService: LoaderService,
              private routingGroupApiService: RoutingGroupApiService) {
  }

  ngOnInit(): void {

  }

  private initializeData(selection: any): void {

    this.prefixGroup = selection;

    if (_.isNil(selection)) {
      return;
    }

    if (selection.length === 1) {
      this.loaderService.showSidePanel();

      const params = {
        prefixGroupId: {
          value: selection[0].id,
          operator: '='
        }
      };

      Promise.all([this.routingRuleApi.getRules({filter: params}),
        this.callStudioApiService.getCallsItemsFiltered({filter: params}),
        this.routingGroupApiService.getGroupsSlim()])
        .then((value) => {

          this.routingGroupIdToNameMap = _.mapValues(_.keyBy(value[2], 'id'), 'name');

          const rules = _.chain(value[0].elements)
            .groupBy('rrGroupId')
            .map((ruleValue, key) => ({[this.routingGroupIdToNameMap[key]]: ruleValue.map(rule => rule.name)})).value();


          this.rules = _.isEmpty(rules) ? 'None' : Object.assign({}, ...rules);

          const policyStudio = value[1].map((rule) => rule.name);

          this.policyStudio = (_.isArray(policyStudio) && policyStudio.length > 0)
            ? policyStudio.join(', ') : 'None';

          this.loaderService.hideSidePanel();
        });
    }
  }
}
